import { useState } from "react";
import { Skeleton } from "primereact/skeleton";
import Section from "../section";
import { useIntl } from "react-intl";
import FormBuilder from "../formBuilder";
import Form from "../form";
import { Button } from "primereact/button";

import "./detail-card.scss";

const DetailsCard = ({
  title,
  details,
  fields,
  isLoading,
  style = {},
  message,
  canUpdate = false,
  onSubmit = () => {},
}) => {
  const intl = useIntl();
  const [isEditabled, setIsEditabled] = useState(false);
  const isCompleted = fields.reduce((acc, field) => {
    acc = acc && (field.value ? true : false);
    return acc;
  }, true);

  const handleSubmit = (values) => {
    onSubmit(values);
    setIsEditabled(false);
  };

  return (
    <div
      className={`edexlms-details-card ${
        isCompleted ? "completed" : "incompleted"
      }`}
      style={style}
    >
      <Section
        title={title}
        i18n={false}
        headerAction={
          (!isEditabled && (
            <Button
              icon="pi pi-pencil"
              outlined
              onClick={() => setIsEditabled(!isEditabled) || null}
              label={intl.formatMessage({ id: "edit" })}
              type="button"
              size="small"
              disabled={!canUpdate}
              tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
              tooltip={
                canUpdate ? "" : intl.formatMessage({ id: "no_permission" })
              }
            />
          )) ||
          null
        }
      >
        {((isLoading || !details) && (
          <Skeleton width="100%" height="100px" />
        )) || <div className="edexlms-details-card"></div>}
        {(!isLoading && details && (
          <>
            <div>
              <Form
                submitBtn={{
                  label: intl.formatMessage({
                    id: "update",
                  }),
                  onClick: handleSubmit,
                }}
                cancelBtn={{
                  label: intl.formatMessage({ id: "cancel" }),
                  onClick: () => setIsEditabled(false),
                }}
                disabled={!isEditabled}
                initialValues={fields.reduce((acc, field) => {
                  const key = field.name || field.label;
                  acc[key] = field.value;
                  return acc;
                }, {})}
              >
                <FormBuilder
                  initialValues={fields.reduce((acc, field) => {
                    const key = field.name || field.label;
                    acc[key] =
                      (field.type.toLowerCase() === "date" &&
                        new Date(field.value)) ||
                      field.value;
                    return acc;
                  }, {})}
                  fields={fields}
                  disabled={!isEditabled}
                />
              </Form>
            </div>
            {(!isCompleted && !isEditabled && (
              <div className="text-muted">{message}</div>
            )) ||
              null}
          </>
        )) ||
          null}
        <div className="edexlms-details-completed">
          <i className="pi pi-check"></i>
        </div>
      </Section>
    </div>
  );
};

export default DetailsCard;
